<template>
  <div :style="styles" class="shared-step-editor-loader"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    styles() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        borderWidth: this.size / 8 + 'px',
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../sass/web/_variables.scss';

.shared-step-editor-loader {
  border: 16px solid $color-alabaster;
  border-radius: 50%;
  border-top: 16px solid $half-baked-color;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
